<header
    class="hu-light:border-primary-header pn-light:bg-primary pn-light:text-white hu-light:bg-primary-header relative z-10 border-b border-solid border-[#EFF0F2] bg-white p-4 shadow-[0_1px_0_#EFF0F2] dark:border-contrast-yellow dark:shadow-[0_1px_0_contrast-yellow] lg:px-14 lg:pb-6 lg:pt-3"
    [ngClass]="{ 'header--mobile-menu-open': mobileMenuOpen === true }">
    <section
        class="hidden border-0 border-b-[0.06rem] border-solid border-[#E4E5E7] pb-3 dark:border-contrast-yellow lg:block">
        <div class="flex items-center">
            <ul class="flex grow flex-wrap gap-x-8">
                <li class="flex items-center justify-center">
                    <mat-icon class="hu-light:text-white mr-1 text-[1rem]">accessibility_new</mat-icon>
                    <button
                        class="pn-light:text-white hu-light:text-white p-1 text-sm dark:text-contrast-yellow"
                        [attr.aria-label]="
                            (isContrast
                                ? 'HEADER_ACCESSIBILITY_NORMAL_CONTRAST_TEXT'
                                : 'HEADER_ACCESSIBILITY_CONTRAST_TEXT'
                            ) | translate
                        "
                        (click)="toggleContrast()"
                        (keydown.enter)="toggleContrast()"
                        (keydown.space)="toggleContrast()"
                        tabindex="0">
                        <span *ngIf="!isContrast">{{ 'HEADER_ACCESSIBILITY_CONTRAST_TEXT' | translate }}</span>
                        <span *ngIf="isContrast">{{ 'HEADER_ACCESSIBILITY_NORMAL_CONTRAST_TEXT' | translate }}</span>
                    </button>
                </li>
                <ng-container *ngIf="!env.HEADER.HIDE_CONTACT_PHONE">
                    <li class="flex items-center justify-center text-sm">
                        <mat-icon class="mr-1 text-[1rem]">call</mat-icon>
                        <a class="pn-light:text-white p-1 text-sm" href="{{ 'HEADER_PHONE_LINK' | translate }}">
                            {{ 'HEADER_PHONE_TEXT' | translate }}
                        </a>
                    </li>
                </ng-container>

                <ng-container *ngIf="!env.HEADER.HIDE_CONTACT_EMAIL">
                    <li class="flex items-center justify-center">
                        <mat-icon class="mr-1 text-[1rem]">mail</mat-icon>
                        <a class="pn-light:text-white p-1 text-sm" href="{{ 'HEADER_MAIL_US_LINK' | translate }}">
                            {{ 'HEADER_MAIL_US' | translate }}
                        </a>
                    </li>
                </ng-container>
            </ul>

            <ul class="login-section ml-4 mr-8 flex shrink-0 items-center justify-end gap-x-8">
                <li class="relative flex items-center justify-center" *ngIf="!hideShoppingIcon">
                    <div class="shopping-cart relative flex items-center">
                        <ng-container *ngIf="!env.ENABLE_PURCHASE_V2; else headerShoppingCartV2">
                            <gl-header-shopping-cart class="text-secondary"></gl-header-shopping-cart>
                            <gl-header-shopping-cart-countdown-timer-visual></gl-header-shopping-cart-countdown-timer-visual>
                        </ng-container>
                        <ng-template #headerShoppingCartV2>
                            <gl-header-shopping-cart-v2></gl-header-shopping-cart-v2>
                        </ng-template>
                    </div>
                </li>

                <ng-container *ngIf="ridangoAuth.getLoginStatus() || !env.HEADER?.HIDE_REGISTRATION_BUTTON">
                    <li class="relative flex items-center justify-center">
                        <mat-icon class="hu-light:text-white mr-1 text-[1rem]">account_circle</mat-icon>
                        <a
                            class="pn-light:text-white hu-light:text-white p-1 text-sm"
                            *ngIf="!ridangoAuth.getLoginStatus()"
                            [routerLink]="'/register' | localize">
                            {{ 'HEADER_SECONDARY_NAV_REGISTER' | translate }}
                        </a>
                        <a
                            class="pn-light:text-white hu-light:text-white p-1 text-sm"
                            *ngIf="ridangoAuth.getLoginStatus()"
                            [routerLink]="'/account' | localize">
                            {{ loggedInCustomer }}
                        </a>
                    </li>

                    <li
                        class="pn-light-dark:bg-white hu-light:bg-white hu-dark:!bg-contrast-yellow h-4 w-[0.1rem] bg-primary-text dark:bg-contrast-yellow"></li>
                </ng-container>

                <li class="flex items-center justify-center">
                    <a
                        class="pn-light:text-white hu-light:text-white p-1 text-sm"
                        *ngIf="!ridangoAuth.getLoginStatus()"
                        [routerLink]="'/login' | localize">
                        {{ 'HEADER_SECONDARY_NAV_LOGIN' | translate }}
                    </a>
                    <button
                        class="pn-light:text-white hu-light:text-white p-1 text-sm text-secondary dark:text-contrast-yellow"
                        *ngIf="ridangoAuth.getLoginStatus()"
                        [attr.aria-label]="'MAIN_MENU_LOGOUT' | translate"
                        (click)="logout()"
                        (keydown.enter)="logout()">
                        {{ 'MAIN_MENU_LOGOUT' | translate }}
                    </button>
                </li>
            </ul>

            <div class="flex flex-wrap">
                <ridango-header-menu-item
                    [languages]="languages"
                    [selected]="selected"
                    (onLanguageSelected)="changeLanguage($event)">
                </ridango-header-menu-item>
            </div>
        </div>
    </section>

    <section class="flex items-center justify-center lg:items-end lg:pt-5">
        <div class="mr-5 flex flex-initial items-center justify-center">
            <button
                class="hamburger hamburger--squeeze mr-6 flex lg:hidden"
                *ngIf="!env.HEADER.HAMBURGER_MENU_TO_RIGHT"
                [ngClass]="{ 'is-active': mobileMenuOpen }"
                [attr.aria-label]="'LOGO' | translate"
                (click)="toggleMobileMenu()"
                title="{{ 'LOGO' | translate }}"
                type="button">
                <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span>
            </button>

            <a class="flex items-center" *ngIf="!env.HEADER?.DISPLAY_BIGGER_LOGO" [routerLink]="'/home' | localize">
                <img
                    class="jk-light-dark:h-8 jk-light-dark:lg:h-10 pn-light-dark:h-8 pn-light-dark:lg:h-10 hu-light-dark:h-12 hu-light-dark:lg:h-16 tmk-light-dark:h-6 tmk-light-dark:lg:h-8 tartu-light-dark:h-8 tartu-light-dark:lg:h-16 h-4 dark:hidden lg:h-6"
                    alt="{{ 'LOGO_ARIA_LABEL' | translate }}"
                    src="{{ assetsPath$ | async }}/img/{{ logoFile }}" />
                <img
                    class="jk-light-dark:h-8 jk-light-dark:lg:h-10 pn-light-dark:h-8 pn-light-dark:lg:h-10 hu-light-dark:h-12 hu-light-dark:lg:h-16 tmk-light-dark:h-6 tmk-light-dark:lg:h-8 tartu-light-dark:h-8 tartu-light-dark:lg:h-16 hidden h-4 dark:filter-yellow dark:block lg:h-6"
                    alt="{{ 'LOGO_ARIA_LABEL' | translate }}"
                    src="{{ assetsPath$ | async }}/img/{{ logoFileContrast }}" />
            </a>
        </div>

        <!--Internal router link-->
        <a
            class="absolute left-4 top-1/2 z-20 flex -translate-y-1/2 transform items-center lg:left-10 lg:top-[70%] lg:-translate-y-1/2"
            *ngIf="env.HEADER?.DISPLAY_BIGGER_LOGO && !env.HEADER?.LOGO_TO_EXTERNAL_LINK"
            [routerLink]="'/home' | localize">
            <img
                class="h-16 dark:hidden lg:h-20"
                alt="{{ 'LOGO_ARIA_LABEL' | translate }}"
                src="{{ assetsPath$ | async }}/img/{{ logoFile }}" />
            <img
                class="hidden h-16 dark:filter-yellow dark:block lg:h-20"
                alt="{{ 'LOGO_ARIA_LABEL' | translate }}"
                src="{{ assetsPath$ | async }}/img/{{ logoFileContrast }}" />
        </a>

        <!--External link-->
        <a
            class="absolute left-4 top-1/2 z-20 flex -translate-y-1/2 transform items-center lg:left-10 lg:top-[70%] lg:-translate-y-1/2"
            *ngIf="env.HEADER?.DISPLAY_BIGGER_LOGO && env.HEADER?.LOGO_TO_EXTERNAL_LINK"
            [href]="'HEADER_LOGO_EXTERNAL_LINK' | translate">
            <img
                class="h-16 dark:hidden lg:h-20"
                alt="{{ 'LOGO_ARIA_LABEL' | translate }}"
                src="{{ assetsPath$ | async }}/img/{{ logoFile }}" />
            <img
                class="hidden h-16 dark:filter-yellow dark:block lg:h-20"
                alt="{{ 'LOGO_ARIA_LABEL' | translate }}"
                src="{{ assetsPath$ | async }}/img/{{ logoFileContrast }}" />
        </a>

        <div class="flex grow items-center justify-end lg:hidden">
            <div class="shopping-cart relative flex items-center">
                <ng-container *ngIf="!env.ENABLE_PURCHASE_V2; else headerShoppingCartV2">
                    <gl-header-shopping-cart class="text-secondary"></gl-header-shopping-cart>
                    <gl-header-shopping-cart-countdown-timer-visual></gl-header-shopping-cart-countdown-timer-visual>
                </ng-container>
                <ng-template #headerShoppingCartV2>
                    <gl-header-shopping-cart-v2></gl-header-shopping-cart-v2>
                </ng-template>
            </div>

            <a
                class="bold flex items-center hover:no-underline"
                [routerLink]="'/account' | localize"
                title="{{ 'ACCOUNT' | translate }}"
                attr.aria-label="{{ 'ACCOUNT' | translate }}">
                <mat-icon
                    class="pn-light:text-white hu-light:text-white mr-1 text-[1.3rem] text-secondary dark:text-contrast-yellow"
                    >account_circle
                </mat-icon>
            </a>

            <ridango-header-menu-item
                [languages]="languages"
                [selected]="selected"
                (onLanguageSelected)="changeLanguage($event)">
            </ridango-header-menu-item>
        </div>

        <button
            class="hamburger hamburger--squeeze pl-6 lg:hidden"
            *ngIf="env.HEADER.HAMBURGER_MENU_TO_RIGHT"
            [ngClass]="{ 'is-active': mobileMenuOpen }"
            [attr.aria-label]="'LOGO' | translate"
            (click)="toggleMobileMenu()"
            title="{{ 'LOGO' | translate }}"
            type="button">
            <span class="hamburger-box">
                <span class="hamburger-inner"></span>
            </span>
        </button>

        <nav class="hidden grow lg:block">
            <ul class="flex flex-wrap justify-end gap-10" (mouseleave)="scheduleClose()">
                <!--New menu with dropdowns-->
                <ng-container *ngIf="useDropdownMenuSystem$ | async">
                    <ng-container *ngFor="let menuItem of dropdownMenuItems$ | async">
                        <li
                            class="menu-item-container relative flex items-baseline"
                            #trigger="cdkOverlayOrigin"
                            *ngIf="isDropdownMenuItemAllowed(menuItem) && !menuItem.isMobileOnly"
                            (mouseenter)="menuItem.hasDropdown && toggleMenu(menuItem.menuId)"
                            cdkOverlayOrigin>
                            <ng-container *ngIf="!menuItem.hasDropdown">
                                <div class="min-h-6 header-menu-link inline-flex items-center">
                                    <a
                                        class="header-menu-link hu-light:text-white inline-flex items-center p-1"
                                        *ngIf="!menuItem.isExternal"
                                        [routerLink]="menuItem.path | localize">
                                        {{ menuItem.label | translate }}
                                    </a>

                                    <a
                                        class="header-menu-link hu-light:text-white inline-flex items-center p-1"
                                        *ngIf="menuItem.isExternal"
                                        [href]="menuItem.path | translate">
                                        {{ menuItem.label | translate }}
                                    </a>
                                </div>
                            </ng-container>

                            <button
                                class="dropdown-menu-button min-h-6 hu-light:text-white inline-flex items-center p-1 align-baseline leading-6"
                                *ngIf="menuItem.hasDropdown"
                                [class.menu-open]="visibleMenu === menuItem.menuId"
                                (keydown.enter)="toggleMenu(menuItem.menuId)"
                                (keydown.escape)="scheduleClose()">
                                {{ menuItem.label | translate }}
                                <span class="dropdown-arrow ml-2 transition-transform duration-200"></span>
                                <div
                                    class="dropdown-container-arrow left-1/2 h-4 w-4 -translate-x-1/2 rotate-45 border-l border-t border-gray-200 bg-white"></div>
                            </button>

                            <ng-template
                                [cdkConnectedOverlayOrigin]="trigger"
                                [cdkConnectedOverlayOpen]="visibleMenu === menuItem.menuId"
                                [cdkConnectedOverlayHasBackdrop]="false"
                                [cdkConnectedOverlayPositions]="dropdownMenuPositions"
                                [cdkConnectedOverlayPush]="true"
                                [cdkConnectedOverlayViewportMargin]="16"
                                cdkConnectedOverlay>
                                <gl-dropdown-menu
                                    [menuData]="(dropdownMenuData$ | async)?.[menuItem.menuId]"
                                    [config]="dropdownMenuConfig[menuItem.menuId]"
                                    (mouseenter)="cancelClose()"
                                    (mouseleave)="scheduleClose()">
                                </gl-dropdown-menu>
                            </ng-template>
                        </li>
                    </ng-container>
                </ng-container>

                <!--Normal menu-->
                <ng-container *ngIf="(useDropdownMenuSystem$ | async) === false">
                    <ng-container *ngFor="let menuItem of menuItems">
                        <li *ngIf="isMenuItemAllowed(menuItem)">
                            <a
                                class="bold pn-light:text-white hu-light:text-white -mb-1 inline-block p-1"
                                *ngIf="menuItem.isExternal"
                                [href]="menuItem.externalUrl">
                                {{ menuItem.label | translate }}
                            </a>

                            <a
                                class="bold pn-light:text-white hu-light:text-white -mb-1 inline-block p-1"
                                *ngIf="!menuItem.isExternal"
                                [routerLink]="menuItem.path | localize">
                                {{ menuItem.label | translate }}
                            </a>
                        </li>
                    </ng-container>
                </ng-container>
            </ul>
        </nav>
    </section>
</header>

<gl-mobile-menu
    *ngIf="mobileMenuOpen"
    [loggedInCustomer]="loggedInCustomer"
    [mobileMenuOpen]="mobileMenuOpen"
    [isContrast]="isContrast"
    (didToggleMobileMenu)="toggleMobileMenu()"
    (didCloseMobileMenu)="closeMobileMenu()"
    (didLanguageChange)="handleLanguageChange($event)"
    (didLogOut)="logout()"
    (themeToggle)="toggleContrast()">
</gl-mobile-menu>
